if (!customElements.get("tab-collection")) {
    customElements.define(
      "tab-collection",
      class TabCollection extends HTMLElement {
        constructor(){
          super();
          console.log($(this)[0])
          this.initTabCollection();
          
        }

        initTabCollection(){
          const that = this;
          $(that).find('.tab_collection_tag').on('click',function(){
            $(this).addClass('tc_active').siblings().removeClass('tc_active');
            let _idx = $(this).index();
            console.log(_idx);
            $(that).find('.tab-collection-content').eq(_idx).addClass('tab_collection_content_active').siblings().removeClass('tab_collection_content_active');
          })
          
          
        }
      }
    )
}